class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = this.querySelector('#cart-notification');
    this.header = document.querySelector('sticky-header');

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onViewportChange = this.updatePosition.bind(this);

    this.notification.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener('click', () => this.close());
    });
  }

  updatePosition() {
    const headerSection = document.querySelector('.section-header');

    const headerBottom = headerSection
      ? Math.min(
          window.innerHeight,
          Math.max(0, headerSection.getBoundingClientRect().bottom)
        )
      : 0;

    this.style.setProperty(
      '--mw-header-bottom',
      `${headerBottom}px`
    );
  }

  open() {
    // Sitúa el aviso fuera de los elementos transformados de la cabecera.
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    requestAnimationFrame(() => {
      this.updatePosition();

      this.notification.classList.add('animate', 'active');

      requestAnimationFrame(() => {
        if (!this.notification.classList.contains('active')) return;

        this.notification.focus();
        trapFocus(this.notification);
      });

      document.body.addEventListener('click', this.onBodyClick);
      window.addEventListener('resize', this.onViewportChange);
      window.addEventListener('scroll', this.onViewportChange, {
        passive: true,
      });
    });
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);
    window.removeEventListener('resize', this.onViewportChange);
    window.removeEventListener('scroll', this.onViewportChange);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);

      target.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;

    if (
      target !== this.notification &&
      !target.closest('#cart-notification')
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
